import { ApolloError, useQuery } from '@apollo/client';
import { PromotionalCard } from 'types/generated';
import { log } from 'utils/log';
import { i18n } from 'utils/setupTranslations';
import { EventIds } from '../../constants';
import { PromotionalCardsRepeaterQuery } from './promotionalCardsRepeater.gql';

export const usePromotionalCardsRepeaterQuery = (): {
    data?: { promotionalCardsRepeater: PromotionalCard[] };
    loading: boolean;
    error?: ApolloError;
} => {
    const { loading, data, error } = useQuery<{
        promotionalCardsRepeater: PromotionalCard[];
    }>(PromotionalCardsRepeaterQuery, {
        variables: {
            locale: i18n.locale,
        },
        notifyOnNetworkStatusChange: true,
        onError: (error: ApolloError) => {
            log.error(
                'Failed to get promotional cards repeater',
                EventIds.GetPromotionalCardsRepeaterFailed,
                error,
            );
        },
        onCompleted: (data: {
            promotionalCardsRepeater: PromotionalCard[];
        }) => {
            if (!data?.promotionalCardsRepeater.length) {
                log.warn(
                    'Receive empty promotional cards repeater',
                    EventIds.GetEmptyPromotionalCardsRepeater,
                    {
                        locale: i18n.locale,
                    },
                );
            }
        },
    });

    return { data, loading, error };
};
